import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useContext } from "react";
import { FormattedMessage } from "react-intl";
import { observer } from "mobx-react-lite";
import { sortBy } from "../../utils/nativeUtils";
import { WithSearch } from "@elastic/react-search-ui";
import { FilterOptionEnum } from "../../models/dataModel";
import { hasProductBeenSelected } from "../../utils/functions";
import { UIStateStoreContext } from "../../stores/uiStateStore";
import { FacetTitle } from "./FacetTitle";
import { MultiSelectFacet } from "./MultiSelectFacet";
const FacetWrapper = observer(({ labelKey, options, showMore, onRemove, onSelect, onMoreClick, }) => {
    const uiStore = useContext(UIStateStoreContext);
    const isOpen = uiStore.isFacetOpen(FilterOptionEnum.VERSION);
    function sortedVersions() {
        const sorted = sortBy(options, (version) => {
            const versionStr = version.value.toString();
            const versionAsNumber = versionStr.endsWith("i")
                ? Number(versionStr.substring(0, versionStr.length - 1)) + 0.5
                : Number(version.value);
            if (!Number.isNaN(versionAsNumber)) {
                return versionAsNumber;
            }
            else if (version.value === "Not version-specific") {
                return 9999;
            }
            else {
                return 0;
            }
        });
        return sorted.reverse();
    }
    return (_jsx(WithSearch, { mapContextToProps: ({ filters }) => ({ filters }), children: ({ filters }) => (_jsx(Fragment, { children: hasProductBeenSelected(filters) ? (_jsx(MultiSelectFacet, { label: labelKey, options: sortedVersions(), onRemove: onRemove, onSelect: onSelect, showMore: showMore, onMoreClick: onMoreClick })) : (_jsxs("div", { className: "sui-facet disabled", "data-testid": "cantSelectVersion", children: [_jsx(FacetTitle, { titleKey: labelKey }), isOpen && (_jsx("span", { className: "small-text", "data-testid": "mustSelectProduct", children: _jsx(FormattedMessage, { id: "mustSelectProduct" }) }))] })) })) }));
});
/**
 * Renders the "Select version" facet.
 * If no product has been selected, displays a 'Must select product first' message.
 * @param label name of the facet
 * @param options options for the facet
 * @param onSelect handles selecting an option
 * @param onRemove handles removing an option
 */
export const SelectVersionFacet = ({ label, options, showMore, onRemove, onSelect, onMoreClick, }) => {
    return (_jsx(FacetWrapper, { labelKey: label, options: options, onRemove: onRemove, onSelect: onSelect, showMore: showMore, onMoreClick: onMoreClick }));
};
